"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withBackGroundStyles = exports.uploadButtonStyles = exports.styles = exports.imageBorderRadius = void 0;
var _react = require("@emotion/react");
var _breakpoints = _interopRequireDefault(require("../../globals/styles/breakpoints"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const imageBorderRadius = exports.imageBorderRadius = '8px';
const styles = exports.styles = {
  grid: /*#__PURE__*/(0, _react.css)("display:grid;grid-template-columns:1fr 1fr 1fr;grid-auto-rows:100px;grid-gap:0.5em;@media screen and (max-width: ", _breakpoints.default.small, "){grid-template-columns:1fr 1fr;}&>div{position:relative;display:flex;border-radius:", imageBorderRadius, ";overflow:hidden;align-items:center;justify-content:center;&:first-of-type{grid-column:1/-1;grid-row:span 3;}&:not(:first-of-type){grid-row:span 2;}}" + (process.env.NODE_ENV === "production" ? "" : ";label:grid;")),
  deleteButton: process.env.NODE_ENV === "production" ? {
    name: "a4hmbt",
    styles: "position:absolute"
  } : {
    name: "1fm46f-deleteButton",
    styles: "position:absolute;label:deleteButton;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  pinButton: process.env.NODE_ENV === "production" ? {
    name: "1s8f2gp",
    styles: "position:absolute;top:0.5em;right:0.5em"
  } : {
    name: "jxq0mc-pinButton",
    styles: "position:absolute;top:0.5em;right:0.5em;label:pinButton;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
const withBackGroundStyles = exports.withBackGroundStyles = {
  default: process.env.NODE_ENV === "production" ? {
    name: "1wnowod",
    styles: "display:flex;align-items:center;justify-content:center"
  } : {
    name: "196ujv6-default",
    styles: "display:flex;align-items:center;justify-content:center;label:default;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  setMainImage: process.env.NODE_ENV === "production" ? {
    name: "19w5sti",
    styles: "width:2em;height:2em;opacity:0.5;border-radius:5px;background-color:grey;padding:0 2px;&:hover{cursor:pointer;opacity:1;}"
  } : {
    name: "x22wlt-setMainImage",
    styles: "width:2em;height:2em;opacity:0.5;border-radius:5px;background-color:grey;padding:0 2px;&:hover{cursor:pointer;opacity:1;};label:setMainImage;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  isMainImage: theme => /*#__PURE__*/(0, _react.css)("width:2em;height:2em;background-color:#f7f7f7;border-radius:5px;color:", theme.primary, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:isMainImage;")),
  delete: theme => /*#__PURE__*/(0, _react.css)("width:3em;height:3em;background-color:#f7f7f7;border:2px solid black;border-radius:50%;&:hover{*{fill:", theme.btnDanger, "!important;}}" + (process.env.NODE_ENV === "production" ? "" : ";label:delete;")),
  imageUpload: process.env.NODE_ENV === "production" ? {
    name: "1d9oiz3",
    styles: "width:3em;height:3em;background-color:transparent;border:2px solid black;border-radius:50%"
  } : {
    name: "11e21kv-imageUpload",
    styles: "width:3em;height:3em;background-color:transparent;border:2px solid black;border-radius:50%;label:imageUpload;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
const uploadButtonStyles = exports.uploadButtonStyles = {
  default: /*#__PURE__*/(0, _react.css)("border:1px dashed #cccccc;border-radius:", imageBorderRadius, ";z-index:10;background-color:transparent;transition:border-color 0.1s;&:hover,&:focus{border-color:black;cursor:pointer;}&>div{display:flex;flex-direction:column;align-items:center;gap:0.5em;pointer-events:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:default;")),
  addImage: process.env.NODE_ENV === "production" ? {
    name: "1v76or3",
    styles: "grid-column:1/-1;grid-row:span 3"
  } : {
    name: "adxr89-addImage",
    styles: "grid-column:1/-1;grid-row:span 3;label:addImage;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  addMore: process.env.NODE_ENV === "production" ? {
    name: "1v6u4im",
    styles: "grid-row:span 2"
  } : {
    name: "l9w6is-addMore",
    styles: "grid-row:span 2;label:addMore;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};